import React, { FunctionComponent, useState, useEffect, useRef } from "react";
import { RootState } from "../../redux/reducers/index";
import { useDispatch, useSelector } from "react-redux";
import { handleCustomShippingValue } from "../../redux/actions/shippingDetailsActions";
import { useHistory } from "react-router-dom";
import {
	ReturnLinkContainer,
	StyledFormGroup,
	StyledTextField,
	TitleSummaryCart,
	StyledLocationOnIcon,
	StyledAccountCircle,
	LoadContainer,
	MarcaBlancaAddressBox,
	MarcaBlancaClientData,
	MarcaBlancaShippingTitle,
	MarcaBlancaDeliveryList,
	MarcaBlancaDeliveryOption,
	MarcaBlancaPayButtonScope,
	MarcaBlancaTermsScope,
} from "./style";
import { InputAdornment } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { v4 as uuid } from "uuid";
import Checkbox from "../../components/CheckBox";
import Spinner from "../../components/Spinner";

import {
	TermsAndConditionsContainer,
	TermsAndConditionsLabel,
	AnchorLink,
	CartPaymentButton,
} from "../../components/CartTotalSummary/style";
import { termsConditions } from "../../redux/actions/termsActions";
import { epayconUrl, privacyPolicy, path } from "../../config/enviroment";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { AddMoreProducts } from "../../components/CartTotalSummary";
import CurrencyFormat, { roundValue } from "../../utils/currencyFormat";
import config, { domain } from "../../config/enviroment";
import { formatDate, adjustmentAmounts } from "../../utils/formatData";
import { getCouponDiscountTotals } from "../../utils/couponDiscount";
import { EpaycoCheckout } from "../../utils/epaycoCheckout";
import { error } from "../../notifications/displayMessage";
import { shouldShowMarcaBlancaModal } from "../../components/MarcaBlancaModal/shouldShow";
import useMarcaBlancaOnboarding from "../../hooks/useMarcaBlancaOnboarding";
import MarcaBlancaGenericErrorModal from "../../components/MarcaBlancaGenericErrorModal";
import CartValidationModal from "../../components/CartValidationModal";
import {
	getCartValidationError,
	getShippingErrors,
	CartValidationResult,
} from "../../utils/cartValidation";
import { getMissingMarcaBlancaFields } from "../../utils/marcaBlancaValidation";
import { datadogLogs } from "@datadog/browser-logs";
import { INACTIVE_CATALOGUE } from "../../redux/actions/homeActions";
import MarcaBlancaOnboardingProgressModal from "../../components/MarcaBlancaOnboardingProgressModal";
import {
	handleResetQuote,
	handleLoadErrorQuote,
	handleRequestQuote,
	handleLoadProviders,
	handleShipCart,
	handleGetAveonlineQuotation,
	EMPTY_CAR,
} from "../../redux/actions";
import { language } from "../../utils/language";
import { isFreeShippingCoupon } from "../../utils/discountTypes";
import { qualifiesForFreeShippingByMinPurchase } from "../../utils/shippingRules";
import { getPhysicalCartSubtotal } from "../../utils/cartSubtotal";
import useBlacklist from "../../hooks/useBlacklist";
import NotificationModal from "../../components/NotificationModal";
import Message from "../../components/Messages";

interface ShippingInfoProps {
	emailClient: string;
	setEmailClient: any;
	loadClient: boolean;
	subTotalAmount: number;
	taxAmountTotal: number;
	consumptionTaxAmountTotal: number;
	setLoadClient: any;
	previousStep?: () => any;
	findQuote?: (operator: string) => any;
	showModal?: boolean;
	shippingCost?: number;
	baseShippingCost?: number;
	isAveonline?: boolean;
	getShippinOperator?: any;
	allProductsDigital?: boolean;
	goToCart?: () => void;
}

const ShippingInfo = ({
	emailClient,
	setEmailClient,
	loadClient,
	setLoadClient,
	subTotalAmount,
	taxAmountTotal,
	consumptionTaxAmountTotal,
	showModal = false,
	previousStep = () => {},
	shippingCost,
	baseShippingCost,
	isAveonline = false,
	allProductsDigital = false,
	getShippinOperator,
	goToCart = () => {},
}: ShippingInfoProps) => {
	const [loading, setLoading] = useState(false);
	const [cartValidation, setCartValidation] =
		useState<CartValidationResult | null>(null);
	const { checkBlacklist } = useBlacklist();
	const blacklistModalRef = useRef<any>();
	const dispatch = useDispatch();
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	const shippingDetailsState: any = useSelector(
		(state: RootState) => state.shippingDetails
	);
	const shoppingCartState: ShoppingCartStateType = useSelector(
		(state: RootState) => state.shoppingCart
	);
	const elogisticaState: any = useSelector(
		(state: RootState) => state.elogistica
	);
	const aveonlineState: any = useSelector(
		(state: RootState) => state.aveonline
	);
	const [acceptTerms, setAcceptTerms] = useState(false);
	const [authorize, setAuthorize] = useState(false);
	const [menssageError, setMenssageError] = useState("");
	const [loadingQuotation, setLoadingQuotation] = useState(false);
	const [selectedCarrier, setSelectedCarrier] = useState<any>(null);
	const history = useHistory();
	const [deliveryQuote, setDeliveryQuote] = useState({
		tcc: null,
		"472": null,
	});
	const [totalDeliveryAmount, setTotalDeliveryAmount] = useState(0);
	const [productHasProvider, setProductHasProvider] = useState(false);
	const [productsWithProvider472, setProductsWithProvider472] = useState([]);
	const [productsWithProviderTCC, setProductsWithProviderTCC] = useState([]);
	const [productsWithoutProvider, setProductsWithoutProvider] = useState([]);
	const [items, setItems] = useState([]);
	const [productDiscountAmount, setProductDiscountAmount] = useState(0);
	const [discountCodeAmount, setDiscountCodeAmount] = useState(0);
	const totalDiscountAmount = productDiscountAmount + discountCodeAmount;
	const [taxAfterDiscount, setTaxAfterDiscount] = useState(0);
	const [consumptionTaxAfterDiscount, setConsumptionTaxAfterDiscount] = useState(0);
	const client: any = useSelector(
		(state: RootState) => state.client
	);
	const marcaBlanca: any = useSelector(
		(state: RootState) => state.marcaBlanca
	);
	const isMarcaBlancaStore = shouldShowMarcaBlancaModal(
		client?.id,
		Number(config.marcaBlancaId)
	);

	const canDeliverAtPoint = Boolean(marcaBlanca.sellerCodeValidated);
	const marcaBlancaBranch = marcaBlanca.branch;

	useEffect(() => {
		if (!isMarcaBlancaStore) {
			return;
		}
		const homeIsUpToDate =
			selectedCarrier?.deliveryType === "home" &&
			selectedCarrier?.value === (shippingCost ?? 0);
		// Sin punto habilitado siempre es domicilio. Con domicilio ya elegido,
		// el precio sigue al costo efectivo (VEN-4007: puede pasar a 0 o volver
		// al costo por defecto al cambiar el subtotal o los cupones).
		const mustSyncHome =
			!canDeliverAtPoint || selectedCarrier?.deliveryType === "home";
		if (mustSyncHome && !homeIsUpToDate) {
			handleMarcaBlancaDelivery("home");
		}
	}, [isMarcaBlancaStore, canDeliverAtPoint, selectedCarrier, shippingCost]);

	// Radicación + código único + afiliación Credibanco, previos a abrir el Checkout.
	const { runOnboarding, currentStep: onboardingStep } = useMarcaBlancaOnboarding();
	const [showGenericError, setShowGenericError] = useState(false);
	const onboardingStepMessage: Record<string, string> = {
		radicate: language[homeState.default_language]["marcaBlancaOnboardingRadicateMessage"],
		merchant: language[homeState.default_language]["marcaBlancaOnboardingMerchantMessage"],
		affiliate: language[homeState.default_language]["marcaBlancaOnboardingAffiliateMessage"],
	};

	useEffect(() => {
		if (isAveonline && !allProductsDigital && shoppingCartState.id && shippingDetailsState.codeDane) {
			setLoadingQuotation(true);
			dispatch(handleGetAveonlineQuotation(
				String(shoppingCartState.id),
				String(shippingDetailsState.codeDane),
				path,
				homeState.default_language
			));
		}
	}, [isAveonline, shoppingCartState.id, shippingDetailsState.codeDane]);

	useEffect(() => {
		if (aveonlineState.quotation !== null || aveonlineState.quotationError !== null) {
			setLoadingQuotation(false);
		}
	}, [aveonlineState.quotation, aveonlineState.quotationError]);

	useEffect(() => {
		const productsRefs = shoppingCartState.cartInfo.filter(
			(item: any) => item.references && item.references.length > 0
		);
		const productsData = shoppingCartState.cartInfo.filter(
			(item: any) => !(item.references && item.references.length > 0)
		);
		if (productsRefs.length > 0) {
			productsRefs.map((product: any) => {
				product.references.map((itemRef: any) => {
					itemRef.data = product.productData.references.find(
						(field: any) => field.id === itemRef.id
					);
					productsData.push({ ...product, references: [itemRef] });
				});
			});
		}
		if (
			productsData.filter(
				(product: any) => product.productData.epaycoDeliveryProvider === true
			).length > 0
		) {
			setProductHasProvider(true);
			if (elogisticaState.providers.length === 0) {
				dispatch(handleLoadProviders());
			}
		} else {
			setProductHasProvider(false);
		}
		setProductsWithoutProvider(
			productsData.filter(
				(item: any) => !item.productData.epaycoDeliveryProvider &&
                        item.productData?.type !== 'digital'
			)
		);
		setProductsWithProviderTCC(
			productsData.filter(
				(item: any) =>
					item.productData.epaycoDeliveryProvider && item.operator === "tcc"
			)
		);
		setProductsWithProvider472(
			productsData.filter(
				(item: any) =>
					item.productData.epaycoDeliveryProvider && item.operator === "472"
			)
		);
		setItems(productsData);

		let totalDiscountProduct = productsData
			.map((cartProduct: any) => {
				const quantity = cartProduct.quantity;
				let discount =
					cartProduct.productData.netAmount !== 0 &&
					cartProduct.productData.discountPrice !== 0
						? cartProduct.productData.netAmount -
						  cartProduct.productData.discountPrice
						: 0;
				if (cartProduct.references && cartProduct.references.length) {
					discount =
						cartProduct.references[0].data.netAmount !== 0 &&
						cartProduct.references[0].data.discountPrice !== 0
							? cartProduct.references[0].data.netAmount -
							  cartProduct.references[0].data.discountPrice
							: 0;
				}
				return quantity * discount;
			})
			?.reduce((acc: any, next: any) => acc + next, 0);
		setProductDiscountAmount(totalDiscountProduct)
	}, [shoppingCartState.cartInfo]);

	useEffect(() => {
		const totals = getCouponDiscountTotals(
			items,
			shippingDetailsState.discountCodes || [],
			subTotalAmount + taxAmountTotal + consumptionTaxAmountTotal,
			taxAmountTotal,
			consumptionTaxAmountTotal,
			homeState.default_language
		);
		setDiscountCodeAmount(totals.discountCodeAmount);
		setTaxAfterDiscount(totals.taxAfterDiscount);
		setConsumptionTaxAfterDiscount(totals.consumptionTaxAfterDiscount);
	}, [items, shippingDetailsState.discountCodes, subTotalAmount, taxAmountTotal, consumptionTaxAmountTotal]);

	useEffect(() => {
		let quoteTcc = findQuote("tcc");
		let quote472 = findQuote("472");
		setDeliveryQuote({
			tcc: quoteTcc,
			"472": quote472,
		});
		if (!homeState.freeDelivery) {
			let total = 0;
			total = total + (quoteTcc === null ? 0 : quoteTcc.valor);
			total = total + (quote472 === null ? 0 : quote472.valor);
			setTotalDeliveryAmount(total);
			dispatch(handleCustomShippingValue(total));
		}
	}, [elogisticaState.requestQuote]);

	const requestQuote = (products: any, operator: string) => {
		if (products.length > 0) {
			const payload = {
				operador: operator,
				id_configuracion: homeState.pickupConfigurationId,
				ciudad_destino: elogisticaState.selectedCity.codigoDane,
				valor_mercancia: products.reduce(sumValueDelivery, 0),
				fecha_guia: formatDate(new Date()),
				envio: products.map((itemP: any) => {
					return {
						cantidad_unidades: itemP.quantity,
						peso_real:
							Math.round(itemP.productData.realWeight) === 0
								? 1
								: Math.round(itemP.productData.realWeight),
						alto: itemP.productData.high,
						largo: itemP.productData.long,
						ancho: itemP.productData.width,
					};
				}),
			};
			dispatch(handleRequestQuote(payload));
		}
	};

	const sumValueDelivery = (acu: any, a: any) => {
		return acu + a.productData.declaredValue;
	};

	useEffect(() => {
		if (elogisticaState.selectedCity.codigoDane !== 0) {
			dispatch(handleResetQuote());
			dispatch(handleLoadErrorQuote(""));
			setMenssageError("");
			calcAmountDelivery();
		}
	}, [elogisticaState.selectedCity.codigoDane]);

	const calcAmountDelivery = () => {
		if (homeState.epaycoDeliveryProvider) {
			let productTcc = shoppingCartState.cartInfo.filter(
				(product: any) => product.operator === "tcc"
			);
			let product472 = shoppingCartState.cartInfo.filter(
				(product: any) => product.operator === "472"
			);
			requestQuote(productTcc, "tcc");
			requestQuote(product472, "472");
		}
	};

	const handleCarrier = (value: any) => {
		const dateDelivery = new Date();
		dateDelivery.setDate(dateDelivery.getDate() + Number(value?.daysDelivery));

		const carrier = {
			...value,
			dateDelivery,
		};

		getShippinOperator(carrier);
		setSelectedCarrier(carrier);
	}
	const handleMarcaBlancaDelivery = (deliveryType: "point" | "home") => {
		const value = deliveryType === "point" ? 0 : (shippingCost ?? 0);
		const carrier = {
			deliveryType,
			value,
			nameCarrier:
				deliveryType === "point"
					? language[homeState.default_language]["mbDeliveryPoint"]
					: language[homeState.default_language]["mbDeliveryHome"],
			daysDelivery: 0,
		};
		getShippinOperator(carrier);
		setSelectedCarrier(carrier);
	};


	type TermsAndConditionsProps = {
		color: string;
		showOnlyOnMobile?: boolean;
		triggerFormValidation?: () => void;
		acceptTerms: boolean;
		authorize: boolean;
	};

	const TermsAndConditions: FunctionComponent<TermsAndConditionsProps> = ({
		color,
		showOnlyOnMobile,
		acceptTerms,
		authorize,
		triggerFormValidation = () => {},
	}) => {
		const dispatch = useDispatch();

		const handleTermsChange = () => {
			triggerFormValidation();
			dispatch(termsConditions({ terms: !acceptTerms, conditions: authorize }));
			setAcceptTerms((prev) => !prev);
		};

		const handleAuthorizeChange = () => {
			triggerFormValidation();
			dispatch(termsConditions({ terms: acceptTerms, conditions: !authorize }));
			setAuthorize((prev) => !prev);
		};

		return (
			<>
				<TermsAndConditionsContainer>
					<div>
						<Checkbox
							checked={acceptTerms}
							color={homeState.color}
							onChange={handleTermsChange}
						/>
						<TermsAndConditionsLabel>
							{language[homeState.default_language]["termsAgreement"]}
							<AnchorLink href={epayconUrl}>
								{language[homeState.default_language]["termsAndConditions"]}
							</AnchorLink>
							{language[homeState.default_language]["termsAgreement2"]}
						</TermsAndConditionsLabel>
					</div>
					<div>
						<Checkbox
							checked={authorize}
							color={homeState.color}
							onChange={handleAuthorizeChange}
						/>
						<TermsAndConditionsLabel>
							{language[homeState.default_language]["authorization3"]}{" "}
							{language[homeState.default_language]["authorization4"]}
							<AnchorLink href={privacyPolicy}>
								{language[homeState.default_language]["authorization2"]}.
							</AnchorLink>
						</TermsAndConditionsLabel>
					</div>
				</TermsAndConditionsContainer>
			</>
		);
	};

	const getIsDisabledPaymentButton = (
		acceptTerms: boolean,
		authorize: boolean
	) => {
		if (isMarcaBlancaStore) {
			return !(acceptTerms && authorize && selectedCarrier);
		}
		if (isAveonline) return !(acceptTerms && authorize && selectedCarrier);
		return !(acceptTerms && authorize);
	};
	

	const handleCheckout = async () => {
		if (loading) return;
		setLoading(true);

		if (
			isMarcaBlancaStore &&
			selectedCarrier?.deliveryType === "point" &&
			!canDeliverAtPoint
		) {
			error(`${language[homeState.default_language]["mbSellerCodeMissing"]}`);
			setLoading(false);
			return;
		}

		// Radicación, código único y afiliación Credibanco: los tres tienen que
		// terminar con éxito, en ese orden, antes de abrir el Checkout.
		if (isMarcaBlancaStore) {
			const missingFields = getMissingMarcaBlancaFields(shippingDetailsState, marcaBlanca.clientId);
			if (missingFields.length > 0) {
				datadogLogs.logger.error("marca blanca checkout data incomplete", {
					cartId: shoppingCartState.id,
					missingFields,
				});
				setLoading(false);
				setShowGenericError(true);
				return;
			}

			const { ok } = await runOnboarding(marcaBlanca.clientId, shippingDetailsState.branchId);
			if (!ok) {
				setLoading(false);
				setShowGenericError(true);
				return;
			}
		}

		let values = { ...shippingDetailsState };
		values.quote = deliveryQuote;
		const couponHasFreeShipping = (shippingDetailsState.discountCodes || []).some(isFreeShippingCoupon);
		const chargedShippingCost = !isAveonline && qualifiesForFreeShippingByMinPurchase(
			homeState.shippingType,
			homeState.freeShippingMinAmount,
			getPhysicalCartSubtotal(shoppingCartState.cartInfo),
			discountCodeAmount
		)
			? 0
			: (baseShippingCost ?? shippingCost ?? 0);
		if (isMarcaBlancaStore) {
			// El envío MB viene de la opción elegida (0 en punto, shippingCost a domicilio).
			values.shippingAmount = couponHasFreeShipping
				? 0
				: selectedCarrier?.deliveryType === "home"
				? chargedShippingCost
				: (selectedCarrier?.value ?? 0);
			values.sellerCode = marcaBlanca.sellerCode;
			// commerceId = ID ePayco validado, guardado en redux marcaBlanca.
			values.commerceId = marcaBlanca.clientId;
			values.deliveryType =
				selectedCarrier?.deliveryType === "point" ? "EN_PUNTO" : "A_DOMICILIO";
		} else if (isAveonline) {
			values.shippingAmount = couponHasFreeShipping ? 0 : selectedCarrier?.value;
			values.carrier = {
				deliveryAmount: selectedCarrier?.value,
				id: Number(selectedCarrier?.idCarrier),
				nameCarrier: selectedCarrier?.nameCarrier,
				daysDelivery: selectedCarrier?.dateDelivery
			};
		} else {
			values.shippingAmount = (homeState.freeDelivery || couponHasFreeShipping) ? 0 : shoppingCartState.customShippingValue;
		}
		values.codeDane = shippingDetailsState.codeDane;
		// En Aveonline y MB el envío ya está en values.shippingAmount; no se debe
		// sumar el shippingCost por defecto del comercio encima.
		let shippingCostValue = (isAveonline || isMarcaBlancaStore || couponHasFreeShipping) ? 0 : chargedShippingCost;
		let totalPay =
			subTotalAmount +
			taxAmountTotal +
			consumptionTaxAmountTotal +
			shippingCostValue +
			values.shippingAmount -
			discountCodeAmount;
		let baseTax = discountCodeAmount ? 
		     (totalPay-(taxAfterDiscount+consumptionTaxAfterDiscount))
			 : subTotalAmount
		let taxAmount = discountCodeAmount ? taxAfterDiscount: taxAmountTotal
		let consumptionTaxAmount = discountCodeAmount ? consumptionTaxAfterDiscount : consumptionTaxAmountTotal
		const dataAmountaAjustment: any = adjustmentAmounts(roundValue(totalPay), roundValue(baseTax), roundValue(taxAmount), roundValue(consumptionTaxAmount), roundValue(shippingCostValue))


		if(homeState.configDataOwner.transactionAmount)
			{
				const transactionAmount = homeState.configDataOwner.transactionAmount[homeState.currency.toLowerCase()];
				
				if(totalPay < parseFloat(transactionAmount.min) || totalPay > parseFloat(transactionAmount.max))
				{
	
					error(`${language[homeState.default_language]["transactionAmountValidation"]}`);
					setLoading(false);
					return;
	
				}
			}

		const shipResponse: any = await dispatch(
			handleShipCart(
				shoppingCartState.id,
				`${domain}/vende/${homeState.catalogueUrlName}`,
				values,
				homeState.default_language,
				dataAmountaAjustment.totalPay,
				roundValue(totalDiscountAmount),
				{
					discountProduct: roundValue((totalDiscountAmount - discountCodeAmount)),
					discountCode: roundValue(discountCodeAmount),
					baseTax: dataAmountaAjustment.baseTax,
					taxAmount: dataAmountaAjustment.taxAmount,
					consumptionTaxAmount: dataAmountaAjustment.consumptionTaxAmount
				}
			) as any
		);

		// El backend revalida tienda, productos, categorías, referencias y precios
		// del carrito; si algo dejó de ser válido no se abre el Checkout.
		const validationError = getCartValidationError(shipResponse);
		if (validationError) {
			setLoading(false);
			setCartValidation(validationError);
			return;
		}

		const shippingErrors = getShippingErrors(shipResponse);
		if (shippingErrors) {
			datadogLogs.logger.error("shipping rejected before checkout", {
				cartId: shoppingCartState.id,
				errors: shippingErrors,
			});
			setLoading(false);
			if (isMarcaBlancaStore) {
				setShowGenericError(true);
			} else {
				error(`${language[homeState.default_language]["transactionError"]}`);
			}
			return;
		}

		const checkoutAddress = values.isAveonline
			? values.address1
			: `${values.address1}, ${values.country} ${values.departament} - ${values.city} / ${values.address2}`;

		if (client.id && client.id == config.epaycoRestricId) {
			const rawDocumentId = shippingDetailsState.documentId || '';
			const numberDocument = shippingDetailsState.documentType === 'NIT'
				? rawDocumentId.replace(/-/g, '')
				: rawDocumentId;
			const isRestricted = await checkBlacklist({
				typeDocument: shippingDetailsState.documentType || '',
				numberDocument,
			})
			.catch(error => {
				console.log(error)
				setLoading(false);
				error(`${language[homeState.default_language]["transactionError"]}`)
			});
			console.log('isRestricted ', isRestricted)
			if (isRestricted) {
				setLoading(false);
				blacklistModalRef.current?.open();
				return;
			}
		}
		

		try{
			await EpaycoCheckout(
				shoppingCartState.id,
				shoppingCartState.clientId,
				homeState.catalogueName,
				shoppingCartState.cartInfo,
				deliveryQuote,
				dataAmountaAjustment.totalPay,
				dataAmountaAjustment.baseTax,
				dataAmountaAjustment.taxAmount,
				dataAmountaAjustment.consumptionTaxAmount,
				roundValue(totalDiscountAmount),
				roundValue(discountCodeAmount),
				`${values.firstName} ${values.lastName}`,
				values.email,
				values.phone,
				checkoutAddress,
				shoppingCartState.publicKey,
				homeState.currency,
				"",
				() => {
					setLoading(false);
				}, homeState.configDataOwner?.integrationPhase
			);
		}catch(errorResponse)
		{
			setLoading(false);
			error(`${language[homeState.default_language]["transactionError"]}`);

		}
	
	};

	const findQuote = (operator: string) => {
		const quotes = elogisticaState.requestQuote.filter(
			(quote: any) => quote.operador === operator
		);
		if (quotes.length > 1) {
			let min = quotes[0].valor;
			let key = 0;
			for (let i = 1; i < quotes.length; i++) {
				if (quotes[i].valor < min) {
					min = quotes[i].valor;
					key = i;
				}
			}
			return quotes[key];
		}
		return quotes && quotes.length > 0 ? quotes[0] : null;
	};

	const handlePreviousStep = async () => {
		previousStep();
	};

	const mappingImgRef = (img: string, imgProduct: string) => {
		return img !== "" ? img : imgProduct;
	};

	const cardContainerOperator = (
		operator: string,
		productsWithProvider: any[]
	) => {
		const operatorData = elogisticaState.providers.find(
			(item: any) => item.operador === operator
		);
		return findQuote(operator) === null && menssageError === "" ? (
			<div>
				<Spinner color={homeState.color} />
			</div>
		) : (
			<div className={"shipping-info"}>
				<div className="shipping-info__heading">
					<div className="shipping-info__heading__title">
						<img src={operatorData?.url_logo} alt="delivery-provider-icon" />
						<span>{language[homeState.default_language]["sentMessage"]}</span>
					</div>
					<div className="shipping-info__heading__price">
						{homeState.epaycoDeliveryProvider &&
						!homeState.freeDelivery &&
						findQuote(operator) !== null ? (
							<div>
								<CurrencyFormat amount={Math.abs(findQuote(operator)?.valor)} />
							</div>
						) : (
							<div>
								{homeState.freeDelivery ? (
									<span>{language[homeState.default_language]["free"]}</span>
								) : (
									<CurrencyFormat amount={0} />
								)}
							</div>
						)}
					</div>
				</div>

				<div className="shipping-info__body">
					{productsWithProvider.map((product: any, index: number) => {
						return (
							<div
								className="shipping-info__body__products-container"
								id="product-row"
								key={uuid()}
							>
								<div className="shipping-info__body__products-image">
									<img
										src={
											product.references && product.references.length > 0
												? mappingImgRef(
														product.references[0].data.img,
														product.productData.img[0]
												  )
												: product.productData.img[0]
										}
										alt={
											product.references && product.references.length > 0
												? mappingImgRef(
														product.references[0].data.img,
														product.productData.img[0]
												  )
												: product.productData.img[0]
										}
									/>
								</div>
								<div>
									<div className="shipping-info__body__product-title">
									<p>{product.productData.title}</p>

										{product.references && product.references.length > 0 && (
											<div className="shipping-info__body__product-subTitle">
												<p className="shipping-info__body__product-reference-title">
													{product.references[0].data.title}
												</p>
											</div>
										)}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	};

	const getImageSrc = (product: any, mappingImgRef: Function) => {
		if (
			product.references &&
			product.references.length > 0 &&
			!product.references[0].data.img.endsWith("/null")
		) {
			return (
				mappingImgRef(
					product.references[0].data.img,
					product.productData.img[0]
				) || product.productData.img[0]
			);
		} else {
			return product.productData.img[0];
		}
	};
	const handleAddress = () => {
		let address: string = '';
		if(isMarcaBlancaStore){
			address = [
				marcaBlancaBranch?.formatted,
				marcaBlancaBranch?.addressDetail,
				marcaBlancaBranch?.cityName,
				marcaBlancaBranch?.regionName,
			].filter(Boolean).join(", ");
		}
		else if(isAveonline){
			address = [
				shippingDetailsState?.streetType,
				shippingDetailsState?.streetName,
				'# ' + shippingDetailsState?.streetNumber+'-'+shippingDetailsState?.crossNumber,
				shippingDetailsState?.housingType,
				shippingDetailsState?.locationDetail+'.',
				shippingDetailsState?.departament,
				shippingDetailsState?.city,
				shippingDetailsState?.additionalAddress
			].filter(Boolean).join(" ");
		}
		else {
			address = [
				shippingDetailsState?.address1,
				shippingDetailsState?.address2,
				shippingDetailsState?.departament,
				shippingDetailsState?.country,
			].filter(Boolean).join(", ");
		}
		return address;
	}

	// El domicilio se cobra al precio del comercio; si ese precio es 0 se lee
	// "Gratis" en vez de "$0", igual que en la entrega del comercio.
	const marcaBlancaHomePrice =
		shippingCost && Number(shippingCost) > 0 ? (
			<CurrencyFormat amount={shippingCost} />
		) : (
			language[homeState.default_language]["free"]
		);

	return (
    <>
      {isMarcaBlancaStore ? (
        <MarcaBlancaClientData>
          <span>{language[homeState.default_language]["dataCommerce"]}</span>

          <MarcaBlancaAddressBox>
            <StyledLocationOnIcon htmlColor={homeState.color} />
            <span>{handleAddress()}</span>
          </MarcaBlancaAddressBox>
        </MarcaBlancaClientData>
      ) : (
      <div className="shipping-info__client-data">
        <span>{language[homeState.default_language]["dataCommerce"]}</span>

        <StyledFormGroup row className="shipping-info_client-data_row">
          <StyledTextField
            variant="outlined"
            placeholder="example@email.com"
            key="email"
            value={emailClient}
            loadClient={loadClient}
            disabled={loadClient}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setEmailClient(event.target.value);
              setLoadClient(false);
            }}
            InputProps={{
              inputProps: {
                "data-testid": "input",
              },
              startAdornment: (
                <InputAdornment position="start" key="userIcon">
                  {/* <AccountCircle style={{height: '30px', width: '30px'}} htmlColor={homeState.color} /> */}
                  <StyledAccountCircle htmlColor={homeState.color} />
                </InputAdornment>
              ),
              endAdornment: (
                <>
                  {loadClient ? (
                    <InputAdornment position="end" key="editIcon">
                      <EditOutlinedIcon
                        htmlColor={homeState.color}
                        onClick={() => handlePreviousStep()}
                        style={{ cursor: "pointer" }}
                      />
                    </InputAdornment>
                  ) : (
                    <></>
                  )}
                </>
              ),
            }}
          />
        </StyledFormGroup>

        <StyledFormGroup row className="shipping-info_client-data_row">
          <StyledTextField
            variant="outlined"
            placeholder="Your shipping address"
            key="shipping"
            value={
              handleAddress()
            }
            loadClient={loadClient}
            disabled={loadClient}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setLoadClient(false);
            }}
            InputProps={{
              inputProps: {
                "data-testid": "input",
              },
              startAdornment: (
                <InputAdornment position="start" key="userIcon">
                  <StyledLocationOnIcon htmlColor={homeState.color} />
                  {/* <svg id='circle-location-icon' data-src={`${config.urlMultimedia}/vende/landing-img/CircleLocationIcon.svg`} /> */}
                </InputAdornment>
              ),
              endAdornment: (
                <>
                  {loadClient ? (
                    <InputAdornment position="end" key="editIcon">
                      <EditOutlinedIcon
                        htmlColor={homeState.color}
                        onClick={() => handlePreviousStep()}
                        style={{ cursor: "pointer" }}
                      />
                    </InputAdornment>
                  ) : (
                    <></>
                  )}
                </>
              ),
            }}
          />
        </StyledFormGroup>
      </div>
      )}

      <div className={"shipping-info-container"}>
        {isMarcaBlancaStore ? (
          <MarcaBlancaShippingTitle className={"shipping-info__container-title"}>
            <TitleSummaryCart
              color={homeState.color}
              isEmpty={shoppingCartState.cartInfo.length <= 0}
            >
              <span>{language[homeState.default_language]["send"]}</span>
            </TitleSummaryCart>
          </MarcaBlancaShippingTitle>
        ) : (
          <div className={"shipping-info__container-title"}>
            <TitleSummaryCart
              color={homeState.color}
              isEmpty={shoppingCartState.cartInfo.length <= 0}
            >
              <span>{language[homeState.default_language]["send"]}</span>
            </TitleSummaryCart>
          </div>
        )}

        {isAveonline && (
          <>
            {loadingQuotation ? (
              <LoadContainer>
                <Spinner color={homeState.color} />
              </LoadContainer>
            ) : aveonlineState.quotationError ? (
							<Message type="error" description={aveonlineState.quotationError} /> 
            ) : aveonlineState.quotation &&
              aveonlineState.quotation.length > 0 ? (
              <div style={{ marginTop: 16, marginBottom: 16 }}>
                <div
                  style={{
                    background: "#F1F1F1",
                    borderRadius: "10px 10px 0 0",
                    padding: "0 8px 0 18px",
										justifyContent: "start",
										alignItems: "center",
										height: 75,
										display: "flex"
                  }}
                >
                  <p
                    style={{ fontWeight: 600, fontSize: 24, color: "#000" }}
                  >
                    {language[homeState.default_language]["sendOperator"]}
                  </p>
                </div>

                <div
                  style={{
                    maxHeight: aveonlineState.quotation.length >= 3 ? 222 : "none",
                    overflowY: aveonlineState.quotation.length >= 3 ? "auto" : "visible",
                    borderRadius: "0 0 10px 10px",
                  }}
                >
                  {aveonlineState.quotation.map((carrier: any) => (
                    <div
                      key={carrier.idCarrier}
                      onClick={() => handleCarrier(carrier)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0px 22px",
                        cursor: "pointer",
												background: "#FFFFFF"
                      }}
                    >
                      <div
                        style={{ display: "flex", alignItems: "center", gap: 12 }}
                      >
                        <input
                          type="radio"
                          readOnly
                          checked={selectedCarrier?.idCarrier === carrier.idCarrier}
                          style={
                            {
                              accentColor: homeState.color,
                              width: 18,
                              height: 18,
                              cursor: "pointer",
                            } as any
                          }
                        />
                        <img
                          src={carrier.logo}
                          alt={carrier.nameCarrier}
                          style={{
                            width: 50,
                            height: 50,
                            objectFit: "contain",
                            borderRadius: 10,
                          }}
                        />
                        <span style={{ fontSize: 18, fontWeight: 400, fontFamily: "Open Sans" }}>
                          {carrier.nameCarrier}
                        </span>
                      </div>
                      <span style={{ fontWeight: 400, fontSize: 18, fontFamily: "Open Sans" }}>
                        <CurrencyFormat amount={carrier.value} />
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </>
        )}

        {!isAveonline && !isMarcaBlancaStore && (
          <>
            {productsWithProvider472.length > 0 ? (
              cardContainerOperator("472", productsWithProvider472)
            ) : (
              <></>
            )}

            {productsWithProviderTCC.length > 0 ? (
              cardContainerOperator("tcc", productsWithProviderTCC)
            ) : (
              <></>
            )}

            {productsWithoutProvider.length > 0 && (
              <div className={"shipping-info"}>
                <div className="shipping-info__heading">
                  <span>
                    {language[homeState.default_language]["deliveryCommerce"]}
                  </span>
                  <span className="cart-total-summary__title">
                    {shippingCost && Number(shippingCost) > 0 ? (
                      <CurrencyFormat amount={shippingCost} />
                    ) : (
                      "Gratis"
                    )}
                  </span>
                </div>

                <div className="shipping-info__body">
                  {productsWithoutProvider.map(
                    (product: any, index: number) => {
                      return (
                        <div
                          className="shipping-info__body__products-container"
                          id="product-row"
                          key={uuid()}
                        >
                          <div className="shipping-info__body__products-image">
                            <img
                              src={getImageSrc(product, mappingImgRef)}
                              alt={getImageSrc(product, mappingImgRef)}
                            />
                          </div>
                          <div>
                            <div className="shipping-info__body__product-title">
                              <p>{product.productData.title}</p>

                              {product.references &&
                                product.references.length > 0 && (
                                  <div className="shipping-info__body__product-subTitle">
                                    <p className="shipping-info__body__product-reference-title">
                                      {product.references[0].data.title}
                                    </p>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            )}
          </>
        )}

				{isMarcaBlancaStore && (
          <MarcaBlancaDeliveryList>
            {canDeliverAtPoint ? (
              <>
                {/* Con código de vendedor validado hay dos opciones y el
                    comercio elige una. */}
                <MarcaBlancaDeliveryOption
                  onClick={() => handleMarcaBlancaDelivery("point")}
                >
                  <div className="marca-blanca-delivery__label">
                    <input
                      type="radio"
                      readOnly
                      checked={selectedCarrier?.deliveryType === "point"}
                      style={{ accentColor: homeState.color, width: 18, height: 18 } as any}
                    />
                    <span>{language[homeState.default_language]["mbDeliveryPoint"]}</span>
                  </div>
                  <span className="marca-blanca-delivery__price">
                    {language[homeState.default_language]["free"]}
                  </span>
                </MarcaBlancaDeliveryOption>

                <MarcaBlancaDeliveryOption
                  onClick={() => handleMarcaBlancaDelivery("home")}
                >
                  <div className="marca-blanca-delivery__label">
                    <input
                      type="radio"
                      readOnly
                      checked={selectedCarrier?.deliveryType === "home"}
                      style={{ accentColor: homeState.color, width: 18, height: 18 } as any}
                    />
                    <span>{language[homeState.default_language]["mbDeliveryHome"]}</span>
                  </div>
                  <span className="marca-blanca-delivery__price">
                    {marcaBlancaHomePrice}
                  </span>
                </MarcaBlancaDeliveryOption>
              </>
            ) : (
              // Sin código validado el domicilio es la única entrega posible:
              // se preselecciona y se muestra como dato, sin radio que quitar.
              <MarcaBlancaDeliveryOption className="marca-blanca-delivery--static">
                <div className="marca-blanca-delivery__label">
                  <span>{language[homeState.default_language]["mbDeliveryHome"]}</span>
                </div>
                <span className="marca-blanca-delivery__price">
                  {marcaBlancaHomePrice}
                </span>
              </MarcaBlancaDeliveryOption>
            )}
          </MarcaBlancaDeliveryList>
        )}

        {isMarcaBlancaStore ? (
          <MarcaBlancaTermsScope>
            <TermsAndConditions
              color={homeState.color}
              acceptTerms={acceptTerms}
              authorize={authorize}
            />
          </MarcaBlancaTermsScope>
        ) : (
          <TermsAndConditions
            color={homeState.color}
            acceptTerms={acceptTerms}
            authorize={authorize}
          />
        )}

        <div className="shipping-info_footer-buttons">
          <ReturnLinkContainer className="return-link-container">
            <a
              style={{ cursor: "pointer", color: `${homeState.color}` }}
              onClick={() => handlePreviousStep()}
              className="return-link"
            >
              <ChevronLeftIcon style={{ color: `${homeState.color}` }} />{" "}
              {language[homeState.default_language]["back"]}
            </a>
          </ReturnLinkContainer>

          <div className="shipping-info__pay-button-container">
            {isMarcaBlancaStore ? (
              <MarcaBlancaPayButtonScope>
                <CartPaymentButton
                  type="submit"
                  color={homeState.color}
                  loading={loading}
                  onClick={handleCheckout}
                  disabled={getIsDisabledPaymentButton(acceptTerms, authorize)}
                >
                  {language[homeState.default_language]["payCart"]}
                </CartPaymentButton>
              </MarcaBlancaPayButtonScope>
            ) : (
              <CartPaymentButton
                type="submit"
                color={homeState.color}
                loading={loading}
                onClick={handleCheckout}
                disabled={getIsDisabledPaymentButton(acceptTerms, authorize)}
              >
                {language[homeState.default_language]["payCart"]}
              </CartPaymentButton>
            )}
            <AddMoreProducts
              language={language[homeState.default_language]["addMoreProducts"]}
              onClick={() =>
                history.push(`/vende/${homeState.catalogueUrlName}/categories`)
              }
            />
          </div>
        </div>
      </div>
      <NotificationModal
        refData={blacklistModalRef}
        message={language[homeState.default_language]["restrictedUser"]}
        textBtn={language[homeState.default_language]["close"]}
        center="center"
        onClose={() => {
          dispatch({ type: EMPTY_CAR });
          history.push(`/vende/${homeState.catalogueUrlName}`);
        }}
				height="50px"
				width="50px"
      />
      <MarcaBlancaOnboardingProgressModal
        open={!!onboardingStep}
        message={onboardingStep ? onboardingStepMessage[onboardingStep] : ""}
      />
      <MarcaBlancaGenericErrorModal
        open={showGenericError}
        color={homeState.color}
        title={language[homeState.default_language]["marcaBlancaOnboardingErrorTitle"]}
        detail={language[homeState.default_language]["marcaBlancaOnboardingErrorMessage"]}
        actionLabel={language[homeState.default_language]["marcaBlancaGenericErrorSupport"]}
        onClose={() => setShowGenericError(false)}
        onAction={() =>
          window.open(config.epaycoSupportTicketUrl, "_blank", "noopener,noreferrer")
        }
      />
      <CartValidationModal
        open={!!cartValidation}
        color={homeState.color}
        defaultLanguage={homeState.default_language}
        result={cartValidation}
        onAccept={() => {
          const storeInactive = cartValidation?.inactiveStore;
          setCartValidation(null);
          if (storeInactive) {
            // App.tsx renderiza <Inactive /> cuando redirectInactive es true.
            dispatch({ type: INACTIVE_CATALOGUE });
            return;
          }
          goToCart();
        }}
      />
    </>
  );
};

export default ShippingInfo;
